// 契約単位の画面の枠（portal.md「画面と操作（契約単位）」）。

import { createContext, useContext, useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { api, messageFor, type Me, type MeMembership } from "../lib/api";
import { currentUser, signIn } from "../lib/auth";
import { selectableMemberships } from "../lib/landing";
import { AppHeader } from "./Header";

interface Ctx { me: Me; membership: MeMembership | null; contractId: string; canManage: boolean }
const ContractCtx = createContext<Ctx | null>(null);
export const useContract = () => useContext(ContractCtx)!;

export function ContractLayout() {
  const { contractId = "" } = useParams();
  const nav = useNavigate();
  const [ctx, setCtx] = useState<Ctx | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (!(await currentUser())) { await signIn(); return; }
      try {
        const me = await api.me();
        const membership = selectableMemberships(me).find((m) => m.contract.contractId === contractId) ?? null;
        const sysadmin = me.platformRole === "system-admin";
        // 所属していない（active でない所属を含む。system-admin でもない）契約の URL は選択画面へ戻す。
        if (!membership && !sysadmin) { nav("/select", { replace: true }); return; }
        setCtx({ me, membership, contractId, canManage: sysadmin || !!membership?.isAdmin });
      } catch (e) {
        setError(messageFor(e));
      }
    })();
  }, [contractId, nav]);

  if (error) return <main><p className="error">{error}</p></main>;
  if (!ctx) return <main><p className="muted">読み込み中…</p></main>;

  const contractName = ctx.membership?.contract.name ?? contractId;

  const tabs = (
    <>
      <NavLink to={`/c/${contractId}`} end>TOP</NavLink>
      {ctx.canManage && <NavLink to={`/c/${contractId}/settings`}>組織設定</NavLink>}
      {ctx.canManage && <NavLink to={`/c/${contractId}/members`}>メンバー</NavLink>}
      {ctx.canManage && <NavLink to={`/c/${contractId}/subscriptions`}>契約</NavLink>}
    </>
  );

  return (
    <ContractCtx.Provider value={ctx}>
      <AppHeader email={ctx.me.email} contractId={contractId} contractName={contractName} tabs={tabs} />
      <Outlet />
    </ContractCtx.Provider>
  );
}

